import { AxiosError } from "axios";
import { axiosFinancial, createAuthHeaders } from "./financialApi";

export const downloadCommissionsB2C = async (
  startDate: Date | string | null,
  endDate: Date | string | null,
  corbanIds?: number[],
  extraFilters?: {
    promotoraId?: number;
    gerenteName?: string;
    vendedorName?: string;
  }
): Promise<void> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    ...(extraFilters?.promotoraId ? { promotoraId: extraFilters.promotoraId } : {}),
    ...(extraFilters?.gerenteName ? { gerenteName: extraFilters.gerenteName } : {}),
    ...(extraFilters?.vendedorName ? { vendedorName: extraFilters.vendedorName } : {}),
  };

  if (corbanIds && corbanIds.length > 0) {
    params.corbanIds = JSON.stringify(corbanIds);
  }

  try {
    const response = await axiosFinancial.get("/api/commissions-b2c-zip", {
      params,
      responseType: "arraybuffer",
      headers: createAuthHeaders(),
    });

    const file = new Blob([response.data], {
      type: "application/zip",
    });

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = "commissions_b2c.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const decoder = new TextDecoder("utf-8");

    if (error instanceof AxiosError && error.response) {
      const errorResponse = decoder.decode(error.response.data);
      const errorObject = JSON.parse(errorResponse);
      console.error(errorObject.error.replace(/^Error:\s/, ""));
      throw new Error(errorObject.error.replace(/^Error:\s/, ""));
    }
    throw new Error(error);
  }
};

export const downloadCommissionsB2B = async (
  startDate: Date | string | null,
  endDate: Date | string | null,
  corbansToRemoveIds?: number[],
  extraFilters?: {
    corbanId?: number;
    promotoraId?: number;
    gerenteName?: string;
    vendedorName?: string;
  }
): Promise<void> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    ...(extraFilters?.corbanId ? { corbanId: extraFilters.corbanId } : {}),
    ...(extraFilters?.promotoraId ? { promotoraId: extraFilters.promotoraId } : {}),
    ...(extraFilters?.gerenteName ? { gerenteName: extraFilters.gerenteName } : {}),
    ...(extraFilters?.vendedorName ? { vendedorName: extraFilters.vendedorName } : {}),
  };

  if (corbansToRemoveIds && corbansToRemoveIds.length > 0) {
    params.corbansToRemoveIds = JSON.stringify(corbansToRemoveIds);
  }

  try {
    const response = await axiosFinancial.get("/api/commissions-b2b-zip", {
      params,
      responseType: "arraybuffer",
      headers: createAuthHeaders(),
    });

    const file = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const formatter = new Intl.DateTimeFormat("pt-BR", {
      timeZone: "America/Sao_Paulo",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedStart = formatter
      .format(new Date(startDate!))
      .replace(/\//g, "-");
    const formattedEnd = formatter
      .format(new Date(endDate!))
      .replace(/\//g, "-");

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Relatório_Corbans_${formattedStart}_${formattedEnd}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error: any) {
    console.log(error)
    const decoder = new TextDecoder("utf-8");

    if (error instanceof AxiosError && error.response) {
      const errorResponse = decoder.decode(error.response.data);
      const errorObject = JSON.parse(errorResponse);
      throw new Error(errorObject.error.replace(/^Error:\s/, ""));
    }
    throw new Error(error);
  }
};

export const getCommissionsB2BPaginated = async (
  startDate: string,
  endDate: string,
  page: number,
  pageSize: number,
  corbansToRemoveIds?: number[],
  vision?: string,
  extraFilters?: {
    corbanId?: number;
    promotoraId?: number;
    gerenteName?: string;
    vendedorName?: string;
  }
): Promise<any> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    page,
    pageSize,
    vision,
    ...(extraFilters?.corbanId ? { corbanId: extraFilters.corbanId } : {}),
    ...(extraFilters?.promotoraId ? { promotoraId: extraFilters.promotoraId } : {}),
    ...(extraFilters?.gerenteName ? { gerenteName: extraFilters.gerenteName } : {}),
    ...(extraFilters?.vendedorName ? { vendedorName: extraFilters.vendedorName } : {}),
  };

  if (corbansToRemoveIds && corbansToRemoveIds.length > 0) {
    params.corbansToRemoveIds = JSON.stringify(corbansToRemoveIds);
  }

  try {
    const response = await axiosFinancial.get(
      "/api/commission-b2b-paginated",
      {
        params,
        headers: createAuthHeaders(),
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.error || error.message || error);
  }
};

export const getCommissionsB2CPaginated = async (
  startDate: string,
  endDate: string,
  page: number,
  pageSize: number,
  filters?: {
    corbanId?: number;
    promotoraId?: number;
    gerenteName?: string;
    vendedorName?: string;
  }
): Promise<any> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    page,
    pageSize,
    ...(filters?.corbanId ? { corbanId: filters.corbanId } : {}),
    ...(filters?.promotoraId ? { promotoraId: filters.promotoraId } : {}),
    ...(filters?.gerenteName ? { gerenteName: filters.gerenteName } : {}),
    ...(filters?.vendedorName ? { vendedorName: filters.vendedorName } : {}),
  };

  try {
    const response = await axiosFinancial.get(
      "/api/commission-b2c-paginated",
      {
        params,
        headers: createAuthHeaders(),
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.error || error.message || error);
  }
};
